import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import ValidationCardForm from "./ValidationCardForm.vue";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.config.devtools = true;

declare const rescData;
Vue.prototype.$rescData = rescData;

new Vue({
  render: h => h(ValidationCardForm)
}).$mount("#validation-card-form");
